export enum ProtectionLevel {
  Public = "public", // anybody can access
  Private = "private", // only logged in users can access
  PublicOnly = "public-only", // only non-logged in users can access
}
